import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CardModule } from '@modules/card/card.module';
import { CardsModule } from '@modules/cards/cards.module';
import { CountdownModule } from '@modules/countdown/countdown.module';
import { MapModule } from '@modules/map/map.module';
import { HighlightSectionComponent } from '@modules/section/highlight-section/highlight-section.component';
import { InfoSectionComponent } from '@modules/section/info-section/info-section.component';
import { SharedModule } from '@modules/shared/shared.module';
import { SliderModule } from '@modules/slider/slider.module';

import { AgendaSectionComponent } from './agenda-section/agenda-section.component';
import { AnnouncementComponent } from './announcement-banner/announcement-banner-large/announcement/announcement.component';
import { AnnouncementBannerLargeComponent } from './announcement-banner/announcement-banner-large/announcement-banner-large.component';
import { AnnouncementBannerSmallComponent } from './announcement-banner/announcement-banner-small/announcement-banner-small.component';
import { AnnouncementBannerComponent } from './announcement-banner/announcement-banner.component';
import { ContactSectionComponent } from './contact-section/contact-section.component';
import { FiltertoolNarrowComponent } from './dynamic-section/components/filtertool-narrow/filtertool-narrow.component';
import { WbMultiSelectComponent } from './dynamic-section/components/wb-multi-select/wb-multi-select.component';
import { DynamicSectionComponent } from './dynamic-section/dynamic-section.component';
import { Equal3SectionComponent } from './equal3-section/equal3-section.component';
import { Equal4SectionComponent } from './equal4-section/equal4-section.component';
import { EventPresentersSectionComponent } from './event-presenter-section/event-presenter-section.component';
import { EventRegistrationSectionComponent } from './event-registration-section/event-registration-section.component';
import { EventRibbonSectionComponent } from './event-ribbon-section/event-ribbon-section.component';
import { HeroSectionComponent } from './hero-section/hero-section.component';
import { PressKitSectionComponent } from './press-kit-section/press-kit-section.component';
import { SectionComponent } from './section/section.component';
import { SectionHeadlineComponent } from './section-headline/section-headline.component';
import { SquareSectionComponent } from './square-section/square-section.component';
import { StageItemComponent } from './stage-section/stage-item/stage-item.component';
import { StageSectionComponent } from './stage-section/stage-section.component';
import { StaggeredSectionComponent } from './staggered-section/staggered-section.component';
import { TestCarSectionComponent } from './test-car-section/test-car-section.component';
import { TestRouteSectionComponent } from './test-route-section/test-route-section.component';

@NgModule({
  declarations: [
    AnnouncementBannerComponent,
    AnnouncementBannerSmallComponent,
    AnnouncementBannerLargeComponent,
    AnnouncementComponent,
    SectionHeadlineComponent,
    Equal3SectionComponent,
    Equal4SectionComponent,
    SquareSectionComponent,
    SectionComponent,
    InfoSectionComponent,
    StaggeredSectionComponent,
    StageSectionComponent,
    ContactSectionComponent,
    StageItemComponent,
    HeroSectionComponent,
    EventRibbonSectionComponent,
    TestCarSectionComponent,
    TestRouteSectionComponent,
    AgendaSectionComponent,
    EventRegistrationSectionComponent,
    EventPresentersSectionComponent,
    HighlightSectionComponent,
    PressKitSectionComponent,
    DynamicSectionComponent,
    FiltertoolNarrowComponent,
    WbMultiSelectComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    CardModule,
    CardsModule,
    CountdownModule,
    SliderModule,
    MapModule,
  ],
  exports: [
    AnnouncementBannerComponent,
    SectionComponent,
    SectionHeadlineComponent,
    Equal3SectionComponent,
    WbMultiSelectComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SectionModule {}
